import { initialListPaginationMeta } from "utils/helpers/pagination";

import {
  SuperModelForm,
  SuperModelFormDropDownState,
  SuperModelState,
} from "../types";

export const initialSuperModelForm: SuperModelForm = {
  name: "",
  manufacturer: "",
  priority: "",
};

export const initialSuperModelMeta = initialListPaginationMeta;

export const initialFormDropDownState: SuperModelFormDropDownState = {
  items: [],
  page: 1,
  perPage: 20,
  meta: initialSuperModelMeta,
  loading: false,
};

export const initialState: SuperModelState = {
  loading: false,
  saving: false,
  list: [],
  page: 1,
  perPage: 20,
  meta: initialSuperModelMeta,
  error: null,
  manufacturerFilter: "ALL",
  manufacturerOptions: [],
  manufacturerOptionsLoading: false,
  manufacturerOptionsError: null,
  isAddModalOpen: false,
  form: initialSuperModelForm,
  formDropDown: { ...initialFormDropDownState },
  detail: null,
  detailLoading: false,
  detailError: null,
};
